// extracted by mini-css-extract-plugin
export default {"form":"FormCategory_form__pNKok","divInput":"FormCategory_divInput__uwz5P"};